export default function simpleToolbarImage(isOperator) {
  const path = window.location.pathname;
  if (path.startsWith("/zones/update/")) return "../../vector-12.svg";
  if (path.startsWith("/zones/representative/update/"))
    return "../../vector-7.svg";
  if (path.startsWith("/refill/update")) return "../../vector-7.svg";
  if (path.startsWith( "/refill/create")) return "../../vector-7.svg";
  switch (path) {
    case "/":
      return isOperator ? "vector-14.svg" : "vector-1.svg";
    case "/doctors-approval":
      return "vector-2.svg";
    case "/active-doctors":
      return "vector-3.svg";
    case "/laboratories":
      return "vector-4.svg";
    case "/products-approval":
      return "vector-5.svg";
    case "/users":
      return "vector-6.svg";
    case "/operators":
      return "vector-7.svg";
    case "/doctor-assignments-top":
      return "vector-7.svg";
    case "/most-requested-products":
      return "vector-7.svg";
    case "/reports":
      return "vector-8.svg";
    case "/categories":
      return "vector-9.svg";
    case "/products":
      return "vector-10.svg";
    case "/assignments":
      return "vector-11.svg";
    case "/assign-to-operator":
      return "vector-12.svg";
    case "/orders":
      return "vector-12.svg";
    case "/business-units":
      return "vector-6.svg";
    case "/samples-to-run-out":
      return "vector-10.svg";
    case "/samples-available":
      return "vector-10.svg";
    case "/history":
      return "vector-13.svg";
    case "/assign-to-representative":
      return "vector-13.svg";
    case "/zones":
      return "vector-6.svg";
    case "/zones/assignment":
      return "../vector-6.svg";
    case "/zones/create":
      return "../vector-12.svg";
    case "/zones/representative":
      return "../vector-7.svg";
    case "/zones/doctors":
      return "../vector-3.svg";
    case "/zones/doctors/zonify":
      return "../../vector-3.svg";
    case "/zones/representative/create":
      return "../../vector-7.svg";
    case "/refill":
      return "../../vector-7.svg";
    case "/refill/create":
      return "../../vector-7.svg";
    case "/refill/doctors":
      return "../../vector-7.svg";
    default:
      return "vector-1.svg";
  }
}
